import { FC, HTMLAttributes } from "react";
import { useStyles } from "./LogoutPopup.styles";
import { StaticImage } from "../StaticImage";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { Dialog } from "../../core/Dialog/Dialog";
import LogoutIcon from "./assets/person.webp";
import LogoutIcon2x from "./assets/person@2x.webp";
import LogoutIcon3x from "./assets/person@3x.webp";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { removePopupQueue } from "../../../store/slices/popup";
import { PopupType } from "../../../constants/popup";
import { logout } from "@onmo/auth";
import { useTranslation } from "react-i18next";

export const LogoutPopup: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { currentPopupId } = useAppSelector((state) => state.popup);
  const dispatch = useAppDispatch();

  const onLogout = async () => {
    try {
      await logout();
      dispatch(removePopupQueue({ type: PopupType.Logout }));
    } catch (error) {
      console.error("Failed to logout", error);
    }
  };

  return (
    <Dialog
      className={classes.root}
      open={currentPopupId === PopupType.Logout}
      mainAction={{
        text: t("common_Not Now"),
        onClick: () => dispatch(removePopupQueue({ type: PopupType.Logout })),
      }}
      secondAction={{
        text: t("settings_Logout"),
        onClick: onLogout,
      }}
    >
      <div className={classes.content}>
        <StaticImage
          src={LogoutIcon}
          src2x={LogoutIcon2x}
          src3x={LogoutIcon3x}
          className={classes.currentImage}
        />
        <Typography variant={TypographyVariant.HeadingH5Bold}>
          {t("common_Want to logout?")}
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
        >
          {t(
            "common_Are you sure? You can always log back in at a later time.",
          )}
        </Typography>
      </div>
    </Dialog>
  );
};
